<div class="feeScheduleCalculator">
  <div class="content position-relative">
    <form (ngSubmit)="submit()" [formGroup]="feeScheduleForm" id="feeScheduleForm" class="">
      <!--Toggle discount and flat fee inputs -->

      <div class="d-flex justify-content-between">

        <div class="input-group">
          Assets Under Management: <span class="input-group-text ms-2">$</span>
          <input class="border" placeholder="Enter Beginning Value" name="initialBalance"
            formControlName="initialBalance" mask="separator.0" thousandSeparator="," (change)="submit()"
            style="width:120px !important">
        </div>
        <div class="form-check form-switch d-flex align-items-center gap-2 mb-0">
          <label class="form-check-label mb-0" for="feeOverrideToggle"></label>
          <input class="form-check-input" type="checkbox" role="switch" id="feeOverrideToggle" title="Advanced Fee Mode"
            [checked]="feeOverrideEnabled" (change)="toggleFeeOverride()"
            style="width:2.5em;height:1.25em;cursor:pointer;accent-color:#6c757d">
        </div>

      </div>
      <table class="table table-striped table-sm">
        <thead>
          <tr>
            <th style="max-width:40px">Tier</th>
            <th class="text-center" style="max-width:280px">Step Amount ($)</th>
            <th class="text-center">Quarterly Fee (%)</th>
            <th class="text-center">Annual Fee (%)</th>
            @if(hasDiscountOrFlatFee) { <th class="text-center">Fee Variance (%)</th> }
            <th class="text-center">Amount In Tier</th>
            <th class="text-center">% In Tier</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let i of feeSchedule; let idx = index;">
            <td style="max-width:40px">{{idx+1}}</td>
            <td class="text-center" style="max-width:280px">{{i.text}}</td>
            <td class="text-center">
              @if(i.feeDiscounted==i.fee) {
              {{i.fee/4|number:'0.4-4'}}
              }
              @else{
              <s>{{i.fee/4|number:'0.4-4'}}</s>
              <span class="ms-2" [title]="i.feeDiscounted/4|number:'1.2-5'">{{i.feeDiscounted/4|number:'0.4-4'}}</span>
              }

            </td>

            <td class="text-center">
              @if(i.feeDiscounted==i.fee) {
              {{i.fee|number:'0.2-2'}}
              }
              @else{
              <s>{{i.fee|number:'0.2-2'}}</s>
              <span class="ms-2" [title]="i.feeDiscounted|number:'1.2-5'">{{i.feeDiscounted|number:'0.2-2'}}</span>
              }

            </td>

            @if(hasDiscountOrFlatFee) {
            <td class="text-center">
              @if((i.discountPercent ?? 0) > 0) {
              {{i.discountPercent|number:'0.2-2'}}%
              } @else {
              —
              }
            </td>
            }

            <td class="text-center">
              @if(i.amt>0){
              {{i.amt|currency:'USD':'symbol':'1.0-0'}}
              }
            </td>
            <td class="text-center" [title]="i.percent|percent:'1.2-5'">
              @if(i.amt>0){
              {{i.percent|percent:'1.2-3'}}
              }
            </td>
          </tr>
        </tbody>
      </table>



      <div class="d-flex justify-content-start align-items-center gap-4 flex-row flex-wrap mt-2">

        @if(feeOverrideEnabled){
        <div class="input-group w-auto d-flex align-items-center">
          Fee Variance:
          <input type="number" min="0" max="100" step="0.01" class="border ms-2 text-end pe-1  p-1" name="discount"
            formControlName="discount" (change)="submit()" style="width:75px !important">
          <span class="input-group-text  p-1">(%)</span>
        </div>
        }
        @if(feeOverrideEnabled){
        <div class="input-group w-auto d-flex align-items-center">
          Flat Fee Override:
          <input type="number" min="0" max="100" step="0.001" class="border ms-2 text-end pe-1 p-1" name="flatFee"
            formControlName="flatFee" (change)="submit()" style="width:85px !important">
          <span class="input-group-text  p-1">(%)</span>
        </div>
        }
        @if(feeOverrideEnabled){
        <button type="button" class="btn btn-outline-secondary btn-sm" (click)="resetFee()">Reset Fee</button>
        }
      </div>



      <div class="mt-3">
        <b [title]="blendedFeeFromSchedule|number:'1.2-5'">Annual Percentage Fee:
          {{blendedFeeFromSchedule|number:'1.2-4'}}%</b><br>
        <!-- <b [title]="blendedRate|number:'1.2-5'">Blended Rate: {{blendedRate|number:'1.2-4'}}%</b><br> -->
      </div>

    </form>
  </div>
  <div class="disclosure">
    *The fee schedule results in a blended fee for assets over $500,000. For example, the blended annual fee for
    $1,000,000 is 0.825% (the First $500,000 at 0.90% and the Next $500,000 at 0.75%). IFA includes related accounts when
    determining asset level for the calculation of advisory fees. Our annual investment advisory fees are billed
    quarterly and payable three months in advance and are based upon the value of assets held in the account (including
    cash, cash equivalents, dividends, and accrued interest) on the last trading day of the month immediately prior to the
    three-month period. Clients will not be billed until they have signed our Client Agreement, completed our Risk
    Capacity Survey ("RCS"), and completed the account opening/transfer process. Fees for portfolio management services
    and Wealth Services are calculated based on the first day assets of any kind appear in an account IFA is authorized to
    manage. Fees are payable three months in advance and are based upon the value of assets held in the account on the
    last trading day of the month immediately prior to the three-month billing period, subject to the adjustments
    described below. Our advisory fee is negotiable at the sole discretion of IFA. Therefore, IFA has clients that are
    charged advisory fees that are lower than what is reflected herein. The advisory fee charged to a client is outlined
    in their client agreement with IFA. IFA has given discounts for families, groups, associations, and for competitive
    reasons. As stated in our Client Agreement, we will deduct our fee directly from your account through the qualified
    custodian holding your funds and securities. Further, the qualified custodian will deliver an account statement to
    you at least quarterly showing all disbursements from your account. Although IFA believes its advisory fees are
    competitive, clients should be aware that lower fees for comparable services may be available from other sources. In
    addition, IFA has the discretion to and has lowered its advisory fees, thereby providing a discount, if and when an
    investment adviser representative leaves IFA. This may serve as an incentive for the client to remain with IFA, as
    such discounts could result in a substantial savings in advisory fees. Please review our brochure<a
      href="https://www.adviserinfo.sec.gov/" target="_blank">https://www.adviserinfo.sec.gov/</a>.
  </div>
</div>